document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".search-tabs__button");
  const panels = document.querySelectorAll(".search-tabs__panel");

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      const target = button.dataset.tab;

      // Toggle boutons
      buttons.forEach(btn => btn.classList.remove("is-active"));
      button.classList.add("is-active");

      // Toggle panels
      panels.forEach(panel => {
        panel.classList.toggle("is-active", panel.dataset.tabPanel === target);
      });
    });
  });
});
